import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ProfilePage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [subscriptionStatus, setSubscriptionStatus] = useState('Active'); // Example status

     const { t, i18n } = useTranslation();
    
    const handleEmailChange = (e) => {
        e.preventDefault();
        // Add logic to update email
        console.log('Email updated to:', email);
    };

    const handlePasswordChange = (e) => {
        e.preventDefault();
        // Add logic to update password
        console.log('Password updated');
    };

    return (
        <div className="profile-page">
            <h1>{t('profile.title')}</h1>

            <section>
                <h2>{t('profile.changeEmail')}</h2>
                <form onSubmit={handleEmailChange}>
                    <label>
                        {t('profile.newEmail')}
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </label>
                    <button type="submit">{t('profile.updateEmail')}</button>
                </form>
            </section>

            <section>
                <h2>{t('profile.changePassword')}</h2>
                <form onSubmit={handlePasswordChange}>
                    <label>
                        {t('profile.newPassword')}
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </label>
                    <button type="submit">{t('profile.updatePassword')}</button>
                </form>
            </section>

            <section>
                <h2>{t('profile.subscriptionStatus')}</h2>
                <p>{t('profile.status')}: {subscriptionStatus}</p>
            </section>
        </div>
    );
};

export default ProfilePage;